import {setup, initApi} from '@eitje/api'
import {HOST} from './environment'
import {notifications} from '~/components'
import {authService} from './auth'
import * as ReactotronModule from 'reactotron-react-js'

const Reactotron = ReactotronModule.default?.default || ReactotronModule

let backend

const init = () => {
	setup({
		alert: notifications.errNotif,
		baseURL: HOST,
		version: 'admin-2.0.0',
		logout: authService.logout,
		getRefreshToken: () => authService.refreshTokenIfNeeded(),
	})
	backend = initApi()
	backend.addMonitor(Reactotron.apisauce)
}

export {init, backend}
